(function () {
  "use strict";

  const SELECTORS = {
    section: ".pc-section",
    table: '[id^="pc-table-"]',
    productsContainer: '[id^="pc-products-"]',
    addPlaceholder: '[id^="pc-add-placeholder-"]',
    addBtn: ".pc-add-btn",
    productCell: ".pc-cell--product",
    valueCell: ".pc-cell--value",
    valuesContainer: ".pc-values-container",
    productLink: ".pc-product-link",
    dropdownTrigger: ".pc-dropdown-trigger",
    dropdownMenu: ".pc-dropdown-menu",
    dropdownText: ".pc-dropdown-text",
    removeBtn: ".pc-remove-btn",
  };

  function formatPrice(cents) {
    if (!cents) return "";
    return `${(cents / 100).toFixed(2).replace(".", ",") } €`;
  }

  function initProductComparison(sectionEl) {
    const { sectionId } = sectionEl.dataset;
    if (!sectionId) return;

    const dataEl = document.getElementById(`pc-data-${sectionId}`);
    if (!dataEl) return;

    let config;
    try {
      config = JSON.parse(dataEl.textContent);
    } catch {
      return;
    }

    const { jsonUrl, currentProduct, maxProducts = 4, minProducts = 2, labels = {} } = config;
    if (!jsonUrl) return;

    fetch(jsonUrl)
      .then((r) => r.json())
      .then((compData) => {
        const products = compData.products || [];
        const defaults = compData.defaults || [];

        const shopifyFetches = products.map((p) =>
          fetch(`/products/${p.handle}.js`)
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null),
        );

        return Promise.all(shopifyFetches).then((shopifyProducts) => {
          const productData = {};
          const allProducts = [];

          products.forEach((p, i) => {
            const sp = shopifyProducts[i];
            const merged = {
              handle: p.handle,
              title: sp ? sp.title : p.name,
              url: sp ? sp.url : `/products/${p.handle}`,
              price: sp ? formatPrice(sp.price) : "",
              image: sp ? sp.featured_image || "" : "",
              booster_type: p.booster_type || "",
              signature_ingredients: p.signature_ingredients || "",
              highlight: p.highlight || "",
              combi_boost: p.combi_boost || "",
              focus: p.focus || 0,
              focus_lightning: p.focus_lightning || false,
              pump: p.pump || 0,
              pump_lightning: p.pump_lightning || false,
              energy: p.energy || 0,
              energy_lightning: p.energy_lightning || false,
              caffeine: p.caffeine || "",
              entry_level: p.entry_level || false,
            };
            productData[p.handle] = merged;
            allProducts.push({ handle: p.handle, title: merged.title });
          });

          startTable(sectionEl, {
            sectionId,
            productData,
            allProducts,
            defaultProducts: defaults,
            currentProduct,
            maxProducts,
            minProducts,
            labels,
          });
        });
      })
      .catch((e) => {
        console.warn("[product-comparison] Failed to load comparison data:", e);
      });
  }

  function startTable(
    sectionEl,
    {
      sectionId,
      productData,
      allProducts,
      defaultProducts,
      currentProduct,
      maxProducts,
      minProducts,
      labels,
    },
  ) {
    const selectedProducts = [];

    const table = sectionEl.querySelector(`[id="pc-table-${sectionId}"]`);
    const productsContainer = sectionEl.querySelector(
      `[id="pc-products-${sectionId}"]`,
    );
    const addPlaceholder = sectionEl.querySelector(
      `[id="pc-add-placeholder-${sectionId}"]`,
    );
    const addBtn = sectionEl.querySelector(SELECTORS.addBtn);
    const productHeaderTemplate = sectionEl.querySelector(
      "#pc-product-header-template",
    );
    const valueCellTemplate = sectionEl.querySelector(
      "#pc-value-cell-template",
    );

    if (
      !table ||
      !productsContainer ||
      !productHeaderTemplate ||
      !valueCellTemplate
    )
      return;

    function updateTableState() {
      if (addPlaceholder) {
        addPlaceholder.hidden = selectedProducts.length >= maxProducts;
      }
      const canRemove = selectedProducts.length > minProducts;
      table.dataset.canRemove = canRemove;

      const removeBtns = table.querySelectorAll(SELECTORS.removeBtn);
      for (let i = 0; i < removeBtns.length; i++) {
        removeBtns[i].style.display = canRemove ? "flex" : "none";
      }
    }

    function closeAllDropdowns() {
      const triggers = sectionEl.querySelectorAll(
        `${SELECTORS.dropdownTrigger}[aria-expanded="true"]`,
      );
      for (let i = 0; i < triggers.length; i++) {
        triggers[i].setAttribute("aria-expanded", "false");
        const menu = triggers[i].nextElementSibling;
        if (menu) {
          menu.style.opacity = "0";
          menu.style.visibility = "hidden";
          menu.style.transform = "translateY(-8px)";
        }
      }
      const openCells = sectionEl.querySelectorAll(".pc-dropdown-open");
      for (let j = 0; j < openCells.length; j++) {
        openCells[j].classList.remove("pc-dropdown-open");
        openCells[j].style.zIndex = "";
      }
    }

    function populateDropdownMenu(menuEl) {
      while (menuEl.firstChild) menuEl.removeChild(menuEl.firstChild);
      allProducts.forEach((product) => {
        const li = document.createElement("li");
        li.setAttribute("role", "option");
        li.dataset.handle = product.handle;
        li.textContent = product.title;
        li.className =
          "py-2.5 px-3.5 text-[13px] text-black cursor-pointer transition-colors duration-150 leading-snug text-left hover:bg-[#f0f0f0]";
        menuEl.appendChild(li);
      });
    }

    function updateDropdownDisabledStates(menu) {
      const selectedHandles = selectedProducts
        .filter((p) => {
          return p.handle;
        })
        .map((p) => {
          return p.handle;
        });

      const items = menu.querySelectorAll("li");
      for (let i = 0; i < items.length; i++) {
        const isSelected =
          selectedHandles.indexOf(items[i].dataset.handle) !== -1;
        items[i].dataset.disabled = isSelected ? "true" : "false";
        items[i].setAttribute("aria-disabled", isSelected);
        if (isSelected) {
          items[i].className =
            "py-2.5 px-3.5 text-[13px] cursor-not-allowed transition-colors duration-150 leading-snug text-left";
          items[i].style.color = "#FDC31E";
          items[i].style.fontWeight = "600";
          items[i].style.background = "#ebebeb";
        } else {
          items[i].className =
            "py-2.5 px-3.5 text-[13px] text-black cursor-pointer transition-colors duration-150 leading-snug text-left hover:bg-[#f0f0f0]";
          items[i].style.color = "";
          items[i].style.fontWeight = "";
          items[i].style.background = "";
        }
      }
    }

    function renderTextValue(cell, value) {
      const span = document.createElement("span");
      if (value && value.trim()) {
        span.className = "leading-normal text-[13px] md:text-sm text-black";
        span.textContent = value;
      } else {
        span.className = "leading-normal text-[13px] md:text-sm text-[#555]";
        span.textContent = labels.noData || "-";
      }
      cell.appendChild(span);
    }

    function renderHighlightValue(cell, value) {
      const span = document.createElement("span");
      if (value && value.trim()) {
        span.className =
          "font-bold text-[#FDC31E] uppercase text-xs md:text-[13px] tracking-wide leading-snug";
        span.textContent = value;
      } else {
        span.className = "leading-normal text-[13px] md:text-sm text-[#555]";
        span.textContent = labels.noData || "-";
      }
      cell.appendChild(span);
    }

    function renderRatingValue(cell, rating, hasLightning) {
      const container = document.createElement("div");
      container.className = "flex items-center gap-[5px]";

      const filledCount = parseInt(rating, 10) || 0;
      const dotFilledTemplate = sectionEl.querySelector(
        "#pc-icon-dot-template",
      );
      const dotEmptyTemplate = sectionEl.querySelector(
        "#pc-icon-dot-empty-template",
      );
      const lightningFilledTemplate = sectionEl.querySelector(
        "#pc-icon-lightning-template",
      );
      const lightningEmptyTemplate = sectionEl.querySelector(
        "#pc-icon-lightning-empty-template",
      );

      for (let i = 0; i < 5; i++) {
        if (i < filledCount && dotFilledTemplate) {
          container.appendChild(dotFilledTemplate.content.cloneNode(true));
        } else if (dotEmptyTemplate) {
          container.appendChild(dotEmptyTemplate.content.cloneNode(true));
        }
      }

      if (hasLightning && lightningFilledTemplate) {
        container.appendChild(lightningFilledTemplate.content.cloneNode(true));
      } else if (lightningEmptyTemplate) {
        container.appendChild(lightningEmptyTemplate.content.cloneNode(true));
      }

      cell.appendChild(container);
    }

    function renderCaffeineValue(cell, value) {
      const isStimfree =
        !value || value === "/" || value.toLowerCase() === "stimfree";

      if (isStimfree) {
        const badge = document.createElement("span");
        badge.className =
          "inline-flex items-center py-[5px] px-3 text-[11px] font-bold uppercase tracking-wider rounded leading-tight bg-[rgba(253,195,30,0.15)] text-[#FDC31E]";
        badge.textContent = labels.stimfree || "Stimfree";
        cell.appendChild(badge);
      } else {
        const span = document.createElement("span");
        span.className = "leading-normal text-[13px] md:text-sm text-black";
        span.textContent = value;
        cell.appendChild(span);
      }
    }

    function renderEntryLevelValue(cell, isEntryLevel) {
      if (isEntryLevel) {
        const checkTemplate = sectionEl.querySelector(
          "#pc-icon-check-template",
        );
        if (checkTemplate) {
          cell.appendChild(checkTemplate.content.cloneNode(true));
        }
      } else {
        const span = document.createElement("span");
        span.className = "leading-normal text-[13px] md:text-sm text-[#555]";
        span.textContent = labels.noData || "-";
        cell.appendChild(span);
      }
    }

    function updateValueCells(columnId, productInfo) {
      const rows = table.querySelectorAll("[data-row]");
      for (let i = 0; i < rows.length; i++) {
        const rowType = rows[i].dataset.row;
        const valueCell = rows[i].querySelector(
          `${SELECTORS.valueCell}[data-column-id="${columnId}"]`,
        );
        if (valueCell) {
          valueCell.dataset.handle = productInfo.handle;
          valueCell.innerHTML = "";

          switch (rowType) {
            case "booster_type":
              renderTextValue(valueCell, productInfo.booster_type);
              break;
            case "signature_ingredients":
              renderTextValue(valueCell, productInfo.signature_ingredients);
              break;
            case "highlight":
              renderHighlightValue(valueCell, productInfo.highlight);
              break;
            case "combi_boost":
              renderTextValue(valueCell, productInfo.combi_boost);
              break;
            case "focus":
              renderRatingValue(
                valueCell,
                productInfo.focus,
                productInfo.focus_lightning,
              );
              break;
            case "pump":
              renderRatingValue(
                valueCell,
                productInfo.pump,
                productInfo.pump_lightning,
              );
              break;
            case "energy":
              renderRatingValue(
                valueCell,
                productInfo.energy,
                productInfo.energy_lightning,
              );
              break;
            case "caffeine":
              renderCaffeineValue(valueCell, productInfo.caffeine);
              break;
            case "entry_level":
              renderEntryLevelValue(valueCell, productInfo.entry_level);
              break;
          }
        }
      }
    }

    function selectProduct(columnId, handle) {
      const productInfo = productData[handle];
      if (!productInfo) return;

      for (let i = 0; i < selectedProducts.length; i++) {
        if (selectedProducts[i].columnId === columnId) {
          selectedProducts[i].handle = handle;
          break;
        }
      }

      const headerCell = productsContainer.querySelector(
        `${SELECTORS.productCell}[data-column-id="${columnId}"]`,
      );
      if (!headerCell) return;

      headerCell.dataset.handle = handle;

      const dropdownText = headerCell.querySelector(SELECTORS.dropdownText);
      if (dropdownText) dropdownText.textContent = productInfo.title;

      const productLink = headerCell.querySelector(SELECTORS.productLink);
      if (productLink) productLink.href = productInfo.url;

      const img = headerCell.querySelector("img");
      if (img && productInfo.image) {
        img.src = productInfo.image;
      }

      const name = headerCell.querySelector("h3");
      if (name) name.textContent = productInfo.title;

      const price = headerCell.querySelector(
        `${SELECTORS.productLink} > span:last-child`,
      );
      if (price) price.textContent = productInfo.price;

      updateValueCells(columnId, productInfo);
    }

    function setupDropdown(headerCell, columnId) {
      const cell = headerCell;
      const trigger = cell.querySelector(SELECTORS.dropdownTrigger);
      const menu = cell.querySelector(SELECTORS.dropdownMenu);

      populateDropdownMenu(menu);

      const showMenu = () => {
        trigger.setAttribute("aria-expanded", "true");
        menu.style.opacity = "1";
        menu.style.visibility = "visible";
        menu.style.transform = "translateY(0)";
        cell.classList.add("pc-dropdown-open");
        cell.style.zIndex = "100";
      };

      const hideMenu = () => {
        trigger.setAttribute("aria-expanded", "false");
        menu.style.opacity = "0";
        menu.style.visibility = "hidden";
        menu.style.transform = "translateY(-8px)";
        cell.classList.remove("pc-dropdown-open");
        cell.style.zIndex = "";
      };

      trigger.addEventListener("click", (e) => {
        e.stopPropagation();
        const isExpanded = trigger.getAttribute("aria-expanded") === "true";

        closeAllDropdowns();

        if (!isExpanded) {
          showMenu();
          updateDropdownDisabledStates(menu);
        }
      });

      menu.addEventListener("click", (e) => {
        const li = e.target.closest("li");
        if (li && li.dataset.handle && li.dataset.disabled !== "true") {
          selectProduct(columnId, li.dataset.handle);
          hideMenu();
        }
      });
    }

    function removeProductColumn(columnId) {
      if (selectedProducts.length <= minProducts) return;

      const headerCell = productsContainer.querySelector(
        `${SELECTORS.productCell}[data-column-id="${columnId}"]`,
      );
      if (headerCell) headerCell.remove();

      const valueCells = table.querySelectorAll(
        `${SELECTORS.valueCell}[data-column-id="${columnId}"]`,
      );
      for (let i = 0; i < valueCells.length; i++) {
        valueCells[i].remove();
      }

      for (let j = selectedProducts.length - 1; j >= 0; j--) {
        if (selectedProducts[j].columnId === columnId) {
          selectedProducts.splice(j, 1);
          break;
        }
      }

      updateTableState();
    }

    function addProductColumn(preselectedHandle) {
      if (selectedProducts.length >= maxProducts) return;

      const headerFragment = productHeaderTemplate.content.cloneNode(true);
      const headerCell = headerFragment.querySelector(SELECTORS.productCell);
      if (!headerCell) return;

      const columnId = `col-${Date.now()}-${Math.random().toString(36).substr(2, 5)}`;
      headerCell.dataset.columnId = columnId;

      if (addPlaceholder) {
        productsContainer.insertBefore(headerCell, addPlaceholder);
      } else {
        productsContainer.appendChild(headerCell);
      }

      const rows = table.querySelectorAll("[data-row]");
      for (let i = 0; i < rows.length; i++) {
        const valuesContainer = rows[i].querySelector(
          SELECTORS.valuesContainer,
        );
        if (valuesContainer) {
          const valueCell = valueCellTemplate.content
            .cloneNode(true)
            .querySelector(SELECTORS.valueCell);
          valueCell.dataset.columnId = columnId;

          if (rows[i].dataset.rowRating === "true") {
            valueCell.style.flexDirection = "row";
            valueCell.style.alignItems = "center";
            valueCell.style.justifyContent = "flex-start";
            valueCell.style.gap = "6px";
          }

          valuesContainer.appendChild(valueCell);
        }
      }

      setupDropdown(headerCell, columnId);

      const removeBtn = headerCell.querySelector(SELECTORS.removeBtn);
      if (removeBtn) {
        removeBtn.addEventListener("click", (e) => {
          e.stopPropagation();
          removeProductColumn(columnId);
        });
      }

      selectedProducts.push({ columnId, handle: null });

      if (preselectedHandle && productData[preselectedHandle]) {
        selectProduct(columnId, preselectedHandle);
      }

      updateTableState();

      headerCell.style.opacity = "0";
      headerCell.style.transform = "translateY(8px)";
      requestAnimationFrame(() => {
        headerCell.style.transition = "opacity 0.3s ease, transform 0.3s ease";
        headerCell.style.opacity = "1";
        headerCell.style.transform = "translateY(0)";
      });
    }

    function initDefaultProducts() {
      let baseDefaults =
        defaultProducts.length >= minProducts
          ? defaultProducts.slice(0, minProducts)
          : allProducts.slice(0, minProducts).map((p) => p.handle);

      if (currentProduct && productData[currentProduct]) {
        const rest = baseDefaults.filter((h) => h !== currentProduct);
        baseDefaults = [currentProduct, ...rest].slice(0, minProducts);
      }

      const validProducts = baseDefaults.filter((handle) => {
        return handle && productData[handle];
      });

      if (validProducts.length === 0) {
        updateTableState();
        return;
      }

      validProducts.forEach((handle) => {
        addProductColumn(handle);
      });

      updateTableState();
    }

    if (addBtn) {
      addBtn.addEventListener("click", () => {
        addProductColumn(null);
      });
    }

    document.addEventListener("click", (e) => {
      if (!e.target.closest(".pc-dropdown")) {
        closeAllDropdowns();
      }
    });

    initDefaultProducts();
  }

  document.addEventListener("DOMContentLoaded", () => {
    const sections = document.querySelectorAll(SELECTORS.section);
    for (let i = 0; i < sections.length; i++) {
      initProductComparison(sections[i]);
    }
  });

  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    document.addEventListener("shopify:section:load", (e) => {
      const section = e.target.querySelector(SELECTORS.section);
      if (section) {
        initProductComparison(section);
      }
    });
  }
})();
